import { createStyles, makeStyles } from '@material-ui/styles';
import CrossPattern from 'assets/avatar/categories/cross-pattern.png';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      margin: '0',
      padding: '5px 10px 5px 10px',
      width: 'fit-content',
      color: palette.text.secondary,
      borderRadius: palette.borderRadius.default,
      fontWeight: 700,
      marginTop: '5px',
      fontSize: '1.25rem'
    },
    grey: {
      color: palette.text.primary,
      background: palette.background.underBox,
      fontSize: '1.5rem'
    },
    danger: {
      backgroundColor: palette.common.red,
      backgroundImage: `url(${CrossPattern})`
    },
    text: {
      margin: '0'
    },
    black: {
      fontWeight: 600,
      color: palette.common.black
    },
    dangerText: {
      fontWeight: 600,
      color: palette.common.white
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
